import { Type, type Static } from "typebox";

const InternalIdSchema = Type.String({ format: "uuid" });

export const BillingAccessStatusV1Schema = Type.Union([
  Type.Literal("entitled"),
  Type.Literal("grace"),
  Type.Literal("blocked"),
]);
export type BillingAccessStatusV1 = Static<typeof BillingAccessStatusV1Schema>;

export const BillingAccessLabelV1Schema = Type.Union([
  Type.Literal("Active"),
  Type.Literal("Grace period"),
  Type.Literal("Blocked"),
]);
export type BillingAccessLabelV1 = Static<typeof BillingAccessLabelV1Schema>;

export const BillingAccountViewV1Schema = Type.Object({
  version: Type.Literal(1),
  organizationId: InternalIdSchema,
  planName: Type.Literal("Design partner"),
  priceLabel: Type.Literal("USD 0"),
  accessStatus: BillingAccessStatusV1Schema,
  accessLabel: BillingAccessLabelV1Schema,
  includedProducts: Type.Tuple([
    Type.Literal("Source"),
    Type.Literal("Codify"),
    Type.Literal("Function"),
    Type.Literal("Radius"),
  ]),
  paymentMethodRequired: Type.Literal(false),
  checkoutAvailable: Type.Literal(false),
  portalAvailable: Type.Literal(false),
}, { additionalProperties: false });
export type BillingAccountViewV1 = Static<typeof BillingAccountViewV1Schema>;
